import React from 'react';
import Modal from '../Modal/Modal';

type Props = {
	show: boolean;
	onClose: () => void;
	onConfirm: () => void;
	itemName: string;
};

function OverwriteModal({ show, onClose, onConfirm, itemName }: Props) {
	return (
		<Modal
			show={show}
			close={onClose}
		>
			<div className="confirm-modal">
				<div className="confirm-modal-header">
					<h1 style={{fontWeight:"bold"}}>이미 등록된 상자 이름입니다.
						<br/>덮어쓰시겠습니까?</h1>
				</div>
				<div className="confirm-modal-body">
					<div className="confirm-modal-warning">
						이전 내용은 복구할 수 없습니다.
					</div>
					<div className="confirm-modal-item-name">
						{itemName}
					</div>
				</div>
				<div className="btns">
					<button
						className="btn medium tertiary"
						onClick={onClose}
					>
						아니요
					</button>
					<button
						className="btn medium secondary"
						onClick={onConfirm}
					>
						예
					</button>
				</div>
			</div>
		</Modal>
	);
}

export default OverwriteModal;
